import { xml2ast } from '@utils/ast';
import { video23AudioParsers } from './spec.23video.audio.js';
import { video23Parsers } from './spec.23video.video.js';
import { boxParsers } from './spec.box.js';
import { fontParsers } from './spec.font.js';
import { iGuideHtmlNodeParsers } from './spec.html.js';
import { preparseCustomBlockTags } from './util.prepare-custom-block-tag.js';

function iGuideHtmlToAst(html, options) {
  return xml2ast(preparseCustomBlockTags(html, ["factbox", "quotebox", "questionbox"]).replace(/\[(audio|video) id="([^"]+)"\]/gi, '<medialibrary$1 id="$2"></medialibrary$1>').replace(/\[23-video id="(.+?)"+?\]/gi, '<video23 data="$1"></video23>').replace(/\[23-video-audio id="(.+?)"+?\]/gi, '<video23audio data="$1"></video23audio>'), {
    ...iGuideHtmlNodeParsers,
    ...fontParsers,
    ...boxParsers,
    ...video23Parsers,
    ...video23AudioParsers
  }, "text/html", {
    context: options
  });
}

export { iGuideHtmlToAst };
//# sourceMappingURL=util.html-to-ast.js.map
